import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import { RemovePaymentMethodParams, removePaymentMethod } from '@utils/backend-api/stripe';

const useRemovePaymentMethod = () => {
  const { mutate, mutateAsync, isLoading, isError } = useMutation(
    (params: RemovePaymentMethodParams) => removePaymentMethod(params),
    {
      onSuccess: () => {
        toast.success('Payment method removed successfully');
      },
      onError: (error: { message: string }) => {
        toast.error(error.message);
      },
    }
  );
  return { mutate, mutateAsync, isLoading, isError };
};

export default useRemovePaymentMethod;
